module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_vis-160426ebe79c3dc9fe3ab0852eca358f.jpg";